import React, { useEffect, useRef, useState } from 'react';
import { iconsPath, imagePath } from '../../utils/imagePath';
import { AddNewProject } from '../ui/UtilsLayout';

const CreateProjectModal = ({ closeModal, onProjectCreated }) => {
  const [activeCategory, setActiveCategory] = useState('Augmented Reality');
  const [selectedProjectType, setSelectedProjectType] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [vrPopup, setVrPopup] = useState(false); // NEW STATE
  const [mrPopup, setMrPopup] = useState(false); // MR STATE
  const [xrPopup, setXrPopup] = useState(false); // XR STATE
  const [showBodyTrackingSub, setShowBodyTrackingSub] = useState(false); // Sub-selection state
  const modelRef = useRef(null);

  const categories = [
    'Augmented Reality',
    'Virtual Reality',
    'Mixed Reality',
    // 'Extended Reality',
  ];

  const handleClickOutside = (event) => {
    if (modelRef.current && !modelRef.current.contains(event.target)) {
      closeModal();
    }
  };
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const projectTypes = [
    {
      id: 'image-target',
      title: 'Image Target',
      description:
        'Create an AR experience that utilizes an image marker to trigger the content experience',
      coming: false,

      img: imagePath?.imageTracking,
    },
    {
      id: 'surface-target',
      title: 'Surface Target',
      description:
        'Create an AR experience that detects a flat surface to anchor your virtual content.',
      coming: false,
      color: 'bg-[#31333A]',
      img: imagePath?.surfaceTracking,
    },
    {
      id: 'world-tracking',
      title: 'World Tracking',
      description:
        'Detects the environment and tracks the device’s position to create an immersive AR experience.',
      coming: false,

      img: imagePath?.worldTracking,
    },
    {
      id: 'location-based',
      title: 'Location-Based AR (VPS)',
      description:
        'Uses GPS and visual positioning to anchor virtual content in real-world locations.',
      coming: false,

      img: imagePath?.locationTracking,
    },

    {
      id: 'body-tracking',
      title: 'Body Tracking',
      description:
        'Detects and maps body movements to interact with virtual content in real time.',
      coming: false,

      img: imagePath?.bodyTracking,
    },
    {
      id: 'area-tracking',
      title: 'Area Tracking',
      description:
        'Detects an environment to anchor and maintain virtual content in real-world spaces.',
      coming: true,

      img: imagePath?.areaTracking,
    },
    {
      id: 'face-tracking',
      title: 'Face Tracking',
      description:
        'Maps facial features to overlay and interact with virtually created content in real time.',
      coming: true,

      img: imagePath?.faceTracking,
    },
  ];

  const bodyTrackingTypes = [
    {
      id: 'hand-tracking',
      title: 'Hand Tracking',
      description:
        'Create an AR experience that utilizes an image marker to trigger the content experience',
      coming: true,
      img: imagePath?.handTracking || imagePath?.bodyTracking,
    },
    {
      id: 'torso-tracking',
      title: 'Torso Tracking',
      description:
        'Create an AR experience that utilizes an image marker to trigger the content experience',
      coming: true,
      img: imagePath?.torsoTracking || imagePath?.bodyTracking,
    },
    {
      id: 'foot-tracking',
      title: 'Foot Tracking',
      description:
        'Create an AR experience that utilizes an image marker to trigger the content experience',
      coming: false,
      img: imagePath?.footTracking || imagePath?.bodyTracking,
    },
    {
      id: 'wrist-tracking',
      title: 'Wrist Tracking',
      description:
        'Create an AR experience that utilizes an image marker to trigger the content experience',
      coming: true,
      img: imagePath?.wristTracking || imagePath?.bodyTracking,
    },
  ];

  return (
    <div className="text-white">
      {/* VR POPUP: If vrPopup is true, show AddNewProject directly for VR */}
      {vrPopup && (
        <AddNewProject
          setIsVisible={() => {
            setVrPopup(false);
            setActiveCategory('Augmented Reality');
          }}
          title={'Virtual Reality'}
          project={'Virtual Reality'}
          closeModal={closeModal}
          category={'Virtual Reality'}
          onProjectCreated={onProjectCreated}
        />
      )}
      {/* MR POPUP: If mrPopup is true, show AddNewProject directly for MR */}
      {mrPopup && (
        <AddNewProject
          setIsVisible={() => {
            setMrPopup(false);
            setActiveCategory('Augmented Reality');
          }}
          title={'Mixed Reality'}
          project={'Mixed Reality'}
          closeModal={closeModal}
          category={'Mixed Reality'}
          onProjectCreated={onProjectCreated}
        />
      )}
      {/* XR POPUP: If xrPopup is true, show AddNewProject directly for XR */}
      {xrPopup && (
        <AddNewProject
          setIsVisible={() => {
            setXrPopup(false);
            setActiveCategory('Augmented Reality');
          }}
          title={'Extended Reality'}
          project={'Extended Reality'}
          closeModal={closeModal}
          category={'Extended Reality'}
          onProjectCreated={onProjectCreated}
        />
      )}
      {/* Only show the rest if not VR, MR, or XR popup */}
      {!isVisible && !vrPopup && !mrPopup && !xrPopup && (
        <div
          ref={modelRef}
          className="bg-[#131418] w-full max-w-[950px] h-[574px] rounded-lg z-[999999999] shadow-xl flex overflow-hidden"
        >
          {showBodyTrackingSub ? (
            <div className="w-full p-6 flex flex-col relative">
              {/* Header */}
              <div className="flex items-center mt-2">
                <button
                  onClick={() => setShowBodyTrackingSub(false)}
                  className="p-2.5 rounded-full bg-[#31333A] hover:bg-[#54565C] transition flex items-center justify-center mr-4"
                >
                  <img src={iconsPath?.group9Image} className="w-4 h-4" alt="Back" />
                </button>
                <div className="flex flex-col">
                  <h1 className="text-[18px] font-bold text-white leading-tight font-inter">Create a New Project</h1>
                  <div className="flex items-center gap-1.5 text-md text-[#9F9F9F] mt-1 font-medium font-inter">
                    <span>New Project</span>
                    <span>&gt;</span>
                    <span>Augmented Reality</span>
                    <span>&gt;</span>
                    <span className="text-[#EDEDED]">Body Tracking</span>
                  </div>
                </div>
              </div>

              {/* Close button */}
              <button
                onClick={closeModal}
                className="absolute top-6 right-6 p-2 rounded-full bg-[#31333A] hover:bg-[#54565C] transition"
              >
                <img src={iconsPath?.group95Image} alt="Close" />
              </button>

              {/* Cards Grid */}
              <div className="grid grid-cols-4 gap-5 mt-10 overflow-y-auto max-h-[420px] scrollbar pb-2">
                {bodyTrackingTypes.map((item) => (
                  <div
                    key={item.id}
                    onClick={() => {
                      if (!item.coming) {
                        setSelectedProjectType(item.title);
                        setIsVisible(true);
                      }
                    }}
                    className={`flex flex-col p-3 bg-[#1C1D21] rounded-xl transition-all border border-[#2D2E33] ${
                      item.coming
                        ? 'opacity-60 cursor-not-allowed'
                        : 'hover:bg-[#31333A] cursor-pointer hover:border-[#54565C]'
                    }`}
                  >
                    <div className="relative rounded-lg overflow-hidden mb-3 aspect-[4/3] bg-[#2A2B30]">
                      <img
                        className="w-full h-full object-cover rounded-lg"
                        src={item.img}
                        alt={item.title}
                      />
                      {item.coming && (
                        <div className="absolute top-2 right-2 bg-[#54565C] text-[8px] py-[2.5px] text-[#EDEDED] px-2.5 rounded-full font-semibold font-inter">
                          Coming soon
                        </div>
                      )}
                    </div>
                    <h3 className="font-semibold text-white text-[13px] mb-1 font-inter">
                      {item.title}
                    </h3>
                    <p className="text-[10px] text-[#9F9F9F] leading-normal font-normal font-inter">
                      {item.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <>
              {/* Left sidebar */}
              <div className="w-1/4 p-6 border-r border-[#4D4D4D]">
                <h1 className="text-[14px] font-medium mb-3">
                  Create a New Project
                </h1>

                <div className="space-y-4">
                  {categories.map((category) => (
                    <button
                      key={category}
                      className={`w-full py-2 px-4 text-left rounded-[50px] text-[12px] transition flex items-center justify-between ${
                        activeCategory === category
                          ? 'bg-[#31333A] text-[#D9D9D9]'
                          : 'text-[#D9D9D9] hover:bg-[#31333A]'
                      }`}
                      onClick={() => {
                        setActiveCategory(category);
                        if (category === 'Virtual Reality') {
                          setVrPopup(true); // Open VR popup directly
                        } else if (category === 'Mixed Reality') {
                          setMrPopup(true); // Open MR popup directly
                        } else if (category === 'Extended Reality') {
                          setXrPopup(true); // Open XR popup directly
                        }
                      }}
                    >
                      <span>{category}</span>
                      {category === 'Mixed Reality' && (
                        <span className=" text-[#EE2B2A] text-[10px] px-2 py-1 rounded font-bold font-inter leading-none">
                          Beta
                        </span>
                      )}
                    </button>
                  ))}
                </div>
              </div>

              {/* Right content */}
              <div className="w-3/4 p-6 flex flex-col  relative">
                {/* Close button */}
                <button
                  onClick={closeModal}
                  className="absolute top-[6px] right-3 p-2 rounded-full bg-[#31333A] hover:bg-[#54565C]"
                >
                  <img src={iconsPath?.group95Image} />
                </button>

                {/* Content area with consistent dimensions */}
                <div className="mt-10">
                  {activeCategory === 'Augmented Reality' ? (
                    <div className="grid grid-cols-3 gap-5 max-h-[500px] scrollbar relative pt-2  overflow-y-auto font-inter">
                      {projectTypes.map((project) => (
                        <div
                          key={project.id}
                          onClick={() => {
                            if (project.id === 'body-tracking') {
                              setShowBodyTrackingSub(true);
                            } else if (
                              project.title === 'Surface Target' ||
                              project.title === 'World Tracking' ||
                              project.title === 'Location-Based AR (VPS)' ||
                              project.title === 'Image Target'
                            ) {
                              setSelectedProjectType(project.title);
                              setIsVisible(true);
                            }
                          }}
                          className="flex p-1 flex-col hover:bg-[#31333A] rounded-lg cursor-pointer"
                        >
                          <div
                            className={` rounded-lg  mb-2 relative  ${project.color}`}
                          >
                            <img className="rounded-[10px]" src={project.img} />
                            {project.coming && (
                              <div className="absolute max-w-[70px] text-nowrap -top-1 -right-[5px] bg-[#54565C] text-[8px] py-[2px] text-[#EDEDED] px-2 rounded-[50px] font-inter">
                                Coming soon
                              </div>
                            )}
                          </div>
                          <h3 className="font-normal mb-1 text-[#EDEDED] text-[13px] font-inter">
                            {project.title}
                          </h3>
                          <p className="text-[10px] max-w-[180px] text-[#9F9F9F] font-inter">
                            {project.description}
                          </p>
                        </div>
                      ))}
                    </div>
                  ) : (
                    // "Coming Soon" - Grid with the same dimensions

                    <div className="    rounded-lg flex items-center justify-center h-full">
                      <span className="text-[#EDEDED] text-xs bg-[#54565C] px-2 py-1 rounded-lg w-fit font-inter">
                        Coming Soon
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      )}

      {isVisible && (
        <>
          {(selectedProjectType === 'Location-Based AR (VPS)' ||
            selectedProjectType === 'Image Target') && (
            <div>
              <AddNewProject
                setIsVisible={setIsVisible}
                project={selectedProjectType}
                title={selectedProjectType}
                closeModal={closeModal}
                onProjectCreated={onProjectCreated}
                goBack={() => {
                  setIsVisible(false);
                  setSelectedProjectType(null);
                }}
              />
            </div>
          )}
          {selectedProjectType === 'Surface Target' && (
            <div>
              <AddNewProject
                setIsVisible={setIsVisible}
                title={'Surface Target'}
                project={selectedProjectType}
                closeModal={closeModal}
                onProjectCreated={onProjectCreated}
                goBack={() => {
                  setIsVisible(false);
                  setSelectedProjectType(null);
                }}
              />
            </div>
          )}
          {selectedProjectType === 'World Tracking' && (
            <div>
              <AddNewProject
                setIsVisible={setIsVisible}
                title={'World Tracking'}
                project={selectedProjectType}
                closeModal={closeModal}
                onProjectCreated={onProjectCreated}
                goBack={() => {
                  setIsVisible(false);
                  setSelectedProjectType(null);
                }}
              />
            </div>
          )}
          {selectedProjectType === 'Foot Tracking' && (
            <div>
              <AddNewProject
                setIsVisible={setIsVisible}
                title={'Foot Tracking'}
                project={selectedProjectType}
                closeModal={closeModal}
                goBack={() => {
                  setIsVisible(false);
                  setSelectedProjectType(null);
                }}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default CreateProjectModal;

// import React, { useEffect, useRef, useState } from 'react';
// import { iconsPath, imagePath } from '../../utils/imagePath';
// import { AddNewProject } from '../ui/UtilsLayout';

// const CreateProjectModal = ({ closeModal }) => {
//   const [activeCategory, setActiveCategory] = useState('Augmented Reality');
//   const [selectedProjectType, setSelectedProjectType] = useState(null);
//   const [isVisible, setIsVisible] = useState(false);
//   const [vrPopup, setVrPopup] = useState(false); // NEW STATE
//   const [mrPopup, setMrPopup] = useState(false); // MR STATE
//   const [xrPopup, setXrPopup] = useState(false); // XR STATE
//   const modelRef = useRef(null);

//   const categories = [
//     'Augmented Reality',
//     'Virtual Reality',
//     'Mixed Reality',
//     'Extended Reality',
//   ];

//   const handleClickOutside = (event) => {
//     if (modelRef.current && !modelRef.current.contains(event.target)) {
//       closeModal();
//     }
//   };
//   useEffect(() => {
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, []);

//   const projectTypes = [
//     {
//       id: 'image-target',
//       title: 'Image Target',
//       description:
//         'Create an AR experience that utilizes an image marker to trigger the content experience',
//       coming: true,

//       img: imagePath?.imageTracking,
//     },
//     {
//       id: 'surface-target',
//       title: 'Surface Target',
//       description:
//         'Create an AR experience that detects a flat surface to anchor your virtual content.',
//       coming: false,
//       color: 'bg-[#31333A]',
//       img: imagePath?.surfaceTracking,
//     },
//     {
//       id: 'world-tracking',
//       title: 'World Tracking',
//       description:
//         'Detects the environment and tracks the device’s position to create an immersive AR experience.',
//       coming: false,

//       img: imagePath?.worldTracking,
//     },
//     {
//       id: 'location-based',
//       title: 'Location-Based AR (VPS)',
//       description:
//         'Uses GPS and visual positioning to anchor virtual content in real-world locations.',
//       coming: false,

//       img: imagePath?.locationTracking,
//     },
//     {
//       id: 'area-tracking',
//       title: 'Area Tracking',
//       description:
//         'Detects an environment to anchor and maintain virtual content in real-world spaces.',
//       coming: true,

//       img: imagePath?.areaTracking,
//     },
//     {
//       id: 'face-tracking',
//       title: 'Face Tracking',
//       description:
//         'Maps facial features to overlay and interact with virtually created content in real time.',
//       coming: true,

//       img: imagePath?.faceTracking,
//     },
//     {
//       id: 'body-tracking',
//       title: 'Body Tracking',
//       description:
//         'Detects and maps body movements to interact with virtual content in real time.',
//       coming: true,

//       img: imagePath?.bodyTracking,
//     },
//   ];

//   return (
//     <div className="flex items-center justify-center min-h-screen text-white p-4">
//       {/* VR POPUP: If vrPopup is true, show AddNewProject directly for VR */}
//       {vrPopup && (
//         <AddNewProject
//           setIsVisible={() => {
//             setVrPopup(false);
//             setActiveCategory('Augmented Reality');
//           }}
//           title={'Virtual Reality'}
//           project={'Virtual Reality'}
//           closeModal={closeModal}
//           category={'Virtual Reality'}
//         />
//       )}
//       {/* MR POPUP: If mrPopup is true, show AddNewProject directly for MR */}
//       {mrPopup && (
//         <AddNewProject
//           setIsVisible={() => {
//             setMrPopup(false);
//             setActiveCategory('Augmented Reality');
//           }}
//           title={'Mixed Reality'}
//           project={'Mixed Reality'}
//           closeModal={closeModal}
//           category={'Mixed Reality'}
//         />
//       )}
//       {/* XR POPUP: If xrPopup is true, show AddNewProject directly for XR */}
//       {xrPopup && (
//         <AddNewProject
//           setIsVisible={() => {
//             setXrPopup(false);
//             setActiveCategory('Augmented Reality');
//           }}
//           title={'Extended Reality'}
//           project={'Extended Reality'}
//           closeModal={closeModal}
//           category={'Extended Reality'}
//         />
//       )}
//       {/* Only show the rest if not VR, MR, or XR popup */}
//       {!isVisible && !vrPopup && !mrPopup && !xrPopup && (
//         <div
//           ref={modelRef}
//           className="bg-[#131418] w-[950px] h-[574px] rounded-lg z-[999999999] shadow-xl flex max-w-4xl"
//         >
//           {/* Left sidebar */}
//           <div className="w-1/4 p-6 border-r border-[#4D4D4D]">
//             <h1 className="text-[14px] font-medium mb-3">
//               Create a New Project
//             </h1>

//             <div className="space-y-4">
//               {categories.map((category) => (
//                 <button
//                   key={category}
//                   className={`w-full py-2 px-4 text-left rounded-[50px] text-[12px] transition ${
//                     activeCategory === category
//                       ? 'bg-[#31333A] text-[#D9D9D9]'
//                       : 'text-[#D9D9D9] hover:bg-[#31333A]'
//                   }`}
//                   onClick={() => {
//                     setActiveCategory(category);
//                     if (category === 'Virtual Reality') {
//                       setVrPopup(true); // Open VR popup directly
//                     } else if (category === 'Mixed Reality') {
//                       setMrPopup(true); // Open MR popup directly
//                     } else if (category === 'Extended Reality') {
//                       setXrPopup(true); // Open XR popup directly
//                     }
//                   }}
//                 >
//                   {category}
//                 </button>
//               ))}
//             </div>
//           </div>

//           {/* Right content */}
//           <div className="w-3/4 p-6 flex flex-col  relative">
//             {/* Close button */}
//             <button
//               onClick={closeModal}
//               className="absolute top-[6px] right-3 p-2 rounded-full bg-[#31333A] hover:bg-[#54565C]"
//             >
//               <img src={iconsPath?.group95Image} />
//             </button>

//             {/* Content area with consistent dimensions */}
//             <div className="mt-10">
//               {activeCategory === 'Augmented Reality' ? (
//                 <div className="grid grid-cols-3 gap-5 max-h-[500px] scrollbar relative pt-2  overflow-y-auto">
//                   {projectTypes.map((project) => (
//                     <div key={project.id} className="flex p-1 flex-col">
//                       <div
//                         onClick={() => {
//                           if (
//                             project.title === 'Surface Target' ||
//                             project.title === 'World Tracking' ||
//                             project.title === 'Location-Based AR (VPS)'
//                           ) {
//                             setSelectedProjectType(project.title);
//                             setIsVisible(true);
//                           }
//                         }}
//                         className={ `rounded-lg  mb-2 relative ${project.color}`}
//                       >
//                         <img className="rounded-[10px]" src={project.img} />
//                         {project.coming && (
//                           <div className="absolute max-w-[70px] text-nowrap -top-1 -right-[5px] bg-[#54565C] text-[8px] py-[2px] text-[#EDEDED] px-2 rounded-[50px]">
//                             Coming soon
//                           </div>
//                         )}
//                       </div>
//                       <h3 className="font-normal mb-1 text-[#EDEDED] text-[13px]">
//                         {project.title}
//                       </h3>
//                       <p className="text-[10px] max-w-[180px] text-[#9F9F9F]">
//                         {project.description}
//                       </p>
//                     </div>
//                   ))}
//                 </div>
//               ) : (
//                 // "Coming Soon" - Grid with the same dimensions

//                 <div className="    rounded-lg flex items-center justify-center h-full">
//                   <span className="text-[#EDEDED] text-xs bg-[#54565C] px-2 py-1 rounded-lg w-fit">
//                     Coming Soon
//                   </span>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}

//       {isVisible && (
//         <>
//           {selectedProjectType === 'Location-Based AR (VPS)' && (
//             <div>
//               <AddNewProject
//                 setIsVisible={setIsVisible}
//                 project={selectedProjectType}
//                 title={'Location-Based AR (VPS)'}
//                 closeModal={closeModal}
//               />
//             </div>
//           )}
//           {selectedProjectType === 'Surface Target' && (
//             <div>
//               <AddNewProject
//                 setIsVisible={setIsVisible}
//                 title={'Surface Target'}
//                 project={selectedProjectType}
//                 closeModal={closeModal}
//               />
//             </div>
//           )}
//           {selectedProjectType === 'World Tracking' && (
//             <div>
//               <AddNewProject
//                 setIsVisible={setIsVisible}
//                 title={'World Tracking'}
//                 project={selectedProjectType}
//                 closeModal={closeModal}
//               />
//             </div>
//           )}
//         </>
//       )}
//     </div>
//   );
// };

// export default CreateProjectModal;
